var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowBoth({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "7px",
    height: "10px",
    viewBox: "0 0 7 10",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon/Carrot/Both") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M0,3.42857143 C0,3.31249942 0.0424102902,3.212054 0.127232143,3.12723214 L3.12723214,0.127232143 C3.212054,0.0424102902 3.31249942,0 3.42857143,0 C3.54464344,0 3.64508886,0.0424102902 3.72991071,0.127232143 L6.72991071,3.12723214 C6.81473257,3.212054 6.85714286,3.31249942 6.85714286,3.42857143 C6.85714286,3.54464344 6.81473257,3.64508886 6.72991071,3.72991071 C6.64508886,3.81473257 6.54464344,3.85714286 6.42857143,3.85714286 L0.428571429,3.85714286 C0.31249942,3.85714286 0.212053996,3.81473257 0.127232143,3.72991071 C0.0424102902,3.64508886 0,3.54464344 0,3.42857143 Z",
    id: "path-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.85714286,0.428571429 C6.85714286,0.544643437 6.81473257,0.645088862 6.72991071,0.729910714 L3.72991071,3.72991071 C3.64508886,3.81473257 3.54464344,3.85714286 3.42857143,3.85714286 C3.31249942,3.85714286 3.212054,3.81473257 3.12723214,3.72991071 L0.127232143,0.729910714 C0.0424102902,0.645088862 0,0.544643437 0,0.428571429 C0,0.31249942 0.0424102902,0.212053996 0.127232143,0.127232143 C0.212053996,0.0424102902 0.31249942,0 0.428571429,0 L6.42857143,0 C6.54464344,0 6.64508886,0.0424102902 6.72991071,0.127232143 C6.81473257,0.212053996 6.85714286,0.31249942 6.85714286,0.428571429 Z",
    id: "path-3"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon/Carrot/Both",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon/Carrot/Close"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Mask"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Tint/Blue/1",
    mask: "url(#mask-2)",
    fill: "#000000",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Tint/DkBlue/1",
    x: 0,
    y: 0,
    width: 7,
    height: 4
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Icon/Carrot/Open",
    transform: "translate(0.000000, 6.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-4",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Mask"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Tint/Blue/1",
    mask: "url(#mask-4)",
    fill: "#000000",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Tint/DkBlue/1",
    x: 0,
    y: 0,
    width: 7,
    height: 4
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowBoth);
export default __webpack_public_path__ + "static/media/arrow-both.4da6f1480179777b1d1adcb716f704a1.svg";
export { ForwardRef as ReactComponent };